module.exports = __webpack_public_path__ + "static/media/ic_write.153754d5.svg";